import React              from 'react';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';

import RenderButton         from '../../../../components/buttons/base/RenderButton';
import { RenderPhoneField } from '../../../../components/fields/redux/RenderPhoneField';
import { RenderTextField }  from '../../../../components/fields/redux/RenderTextField';

function ChangeProfileData({ ...props }) {
  const {
          cancel,
          email,
          form,
          handleSubmit,
          submitForm,
        }     = props;
  const { t } = useTranslation();

  if (!isSSR()) {
    scrollTo({
      top:  0,
      left: 0,
    });
  }

  return (
    <form
      name={form}
      className={form}
      noValidate={true}
      method={'post'}
      onSubmit={event => submitForm(event, handleSubmit)}
    >
      <section>
        <div className={'container'}>
          <div className={'line'}>
            <RenderTextField
              name={'lastName'}
              label={t('field_lastName')}
            />
          </div>
          <div className={'line'}>
            <RenderTextField
              name={'firstName'}
              label={t('field_firstName')}
            />
          </div>
          <div className={'line'}>
            <RenderTextField
              name={'patronymic'}
              label={t('field_patronymic')}
            />
          </div>
          <div className={'line'}>
            <span>E-mail:</span>
            <div>{email}</div>
          </div>
          <div className={'line'}>
            <RenderTextField
              name={'login'}
              label={t('field_login')}
            />
          </div>
          <div className={'line'}>
            <RenderPhoneField
              name={'phone'}
              label={t('field_phone')}
            />
          </div>
          <div className={'line'}>
            <RenderTextField
              name={'address'}
              label={t('field_address')}
            />
          </div>
        </div>
      </section>
      <section className={'to-catalog'}>
        <div className={'container'}>
          <RenderButton
            type={'submit'}
            className={'fill'}
            label={t('btn_save')}
          />
          <RenderButton
            action={cancel}
            label={t('btn_cancel')}
          />
        </div>
      </section>
    </form>
  );
}

export default reduxForm({
  form:         'ChangeProfileData',
  validate:     () => {
  },
  onSubmitFail: (errors, dispatch) => {
  },
})(ChangeProfileData);